export default "__VITE_ASSET__C$UW05w6__"